import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Subscribe to the `prefers-reduced-motion` media query. Returns `true` when
 * the user has expressed a preference for reduced motion. Use this to gate
 * JS-driven animations (Recharts `animationDuration`, framer transitions,
 * etc.); CSS-driven animations should use the corresponding `@media` block
 * directly. d-orca is CSR-only so we don't guard `typeof window`, but jsdom
 * (test environment) does not implement `matchMedia` — hence the presence
 * check on the API itself.
 */
export function useReducedMotion(): boolean {
  const [prefers, setPrefers] = useState<boolean>(() =>
    typeof window.matchMedia === 'function' ? window.matchMedia(QUERY).matches : false,
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(QUERY);
    const listener = (event: MediaQueryListEvent) => setPrefers(event.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  return prefers;
}
